<template lang="html">
  <div>
      <div class="inner-page">
          <Header>意见反馈</Header>
          <div class="scroll-list" :style="'height:' + scrollH + 'px'">
              <div class="scroll-inner">
                  <div class="suggest-block">
                       <div class="suggest-ttl">请将您宝贵的意见告诉我们，我们将重视每一条反馈。</div>
                       <div class="suggest-text">
                            <textarea v-model="suggest" name="name" placeholder="请输入您的建议，5字以上..."></textarea>
                       </div>
                  </div>

                  <div class="tel-block">
                      <div class="tel-ttl">您的联系方式（手机号或邮箱）</div>
                      <div class="tel-text">
                           <input v-model="conText" name="name" placeholder="请输入手机号或邮箱" />
                      </div>
                  </div>

                  <div class="sub-btn" @click="goCommit">提交</div>
              </div>
              <Footer />
          </div>

      </div>

  </div>
</template>

<script>
import vEmits from '@/utils/vEmits';
import { subSuggest } from '@/api/me';
export default {
    data(){
        return{
            suggest:'',
            conText:'',
            scrollH:''
        }
    },
    methods:{
        goCommit:function(){
             let vtext = this.suggest.replace(/\s+/g,"");
             if(vtext.length > 0){
                 if(vtext.length < 5){
                      vEmits.$emit('show','字数过少');
                 }else{
                      let vues = this;
                      subSuggest({
                           userId:this.$store.state.user.userId,
                           feedback:vtext,
                           questionType:1
                      }).then(res => {
                          window.console.log(res);
                           vEmits.$emit('show','提交成功 !');
                           vues.suggest = '';
                           vues.conText = ''
                      })
                 }
             }else{
                 vEmits.$emit('show','请填写意见');
             }

        }
    },
    created:function(){
         this.scrollH = document.documentElement.clientHeight - 107;
    }
}
</script>

<style lang="css" scoped>

.inner-page{
    padding-bottom: 30px;
}

.scroll-list{
    overflow-y: scroll;
}

.scroll-inner{
    background: white;
}

/* 意见输入 */

.suggest-block{
    margin: 0 15px;
}

.suggest-block .suggest-ttl{
    font-size: 14px;
    padding-top: 12px;
}

.suggest-text{
    width: 100%;
    height: 100px;
    border: 1px solid #efefef;
    margin-top: 9px;
    border-radius: 3px;
    display: flex;
}

.suggest-text textarea{
    width: 100%;
    padding: 6px 10px;
    box-sizing: border-box;
    border: none;
    resize: none;
    color: #666666;
    font-size: 14px;
}

/* 电话 */

.tel-block{
    margin: 0 15px;
    margin-top: 18px;
}

.tel-block .tel-ttl{
    font-size: 14px;
}

.tel-block .tel-text{
    height: 32px;
    border: none;
    margin-top: 6px;
    border: 1px solid #efefef;
    padding: 0 10px;
    box-sizing: border-box;
}

.tel-block .tel-text input{
    border: none;
    height: 28px;
    width: 100%;
    font-size: 14px;
    color: #666666;
}

/* 提交 */

.sub-btn{
    height: 40px;
    border: 1px solid #af2d2d;
    text-align: center;
    line-height: 40px;
    margin: 0 15px;
    margin-top: 24px;
    border-radius: 3px;
}

</style>
